import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { share } from 'rxjs/operators';

import { User } from '../interfaces/common/users';

@Injectable({
  providedIn: 'root',
})
export class UserStore {
  private readonly userKey = 'currentUser';

  protected userState$ = new BehaviorSubject<User | {}>(this.loadInitialState());

  constructor() {
    this.userState$.subscribe(user => {
      localStorage.setItem(this.userKey, JSON.stringify(user));
    });
  }

  private loadInitialState(): any | {} {
    try {
      const user = localStorage.getItem(this.userKey);
      return user ? JSON.parse(user) : {};
    } catch (e) {
      console.error('Error while retriving user from localStorage', e);
      return {};
    }
  }

  getUser(): any {
    return this.userState$.value;
  }

  setUser(paramUser: any): void {
    this.userState$.next(paramUser);
  }

  onUserStateChange(): any {
    return this.userState$.pipe(share());
  }

  clearUser(): void {
    localStorage.removeItem(this.userKey);
    this.userState$.next({});
  }
}
